import { render, staticRenderFns } from "./answer-summary.vue?vue&type=template&id=18678b4c"
import script from "./answer-summary.vue?vue&type=script&lang=js"
export * from "./answer-summary.vue?vue&type=script&lang=js"
import style0 from "./answer-summary.vue?vue&type=style&index=0&id=18678b4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports